import { Grid, styled } from '@material-ui/core'

export const CARDS_HEIGHT = 330

export const Wrapper = styled(Grid)(({ theme }) => ({
  width: '100%',
  height: '100%',
  boxSizing: 'border-box',
  overflowY: 'auto',
}))

export const Cards = styled(Grid)(({ theme }) => ({
  width: '100%',
  height: CARDS_HEIGHT,
}))

export const SpinnerWrapper = styled(Grid)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: `${theme.palette.grey[500]}f0`,
  zIndex: 999,
  position: 'absolute',
  top: 0,
  left: 0,
}))
